import { FormControl, FormField, FormItem } from "@/src/components/ui/form";
import { ComboboxMulti } from "../../../../components/ui/combobox-multi";
import { YachtsFiltersFormT } from "./yachts-filters.schema";
import { boatsFetch } from "../../../../lib/boatsFetch";

export function Manufacturers() {
  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full mb-3">Manufacturers</h3>
      <FormField<YachtsFiltersFormT, "manufacturer">
        name="manufacturer"
        render={({ field }) => {
          return (
            <FormItem>
              <FormControl>
                <ComboboxMulti
                  className="flex w-full"
                  loadOptions={(query) =>
                    boatsFetch<{ data: string[] }>(`/search/manufacturers?query=${query}`).then((r) =>
                      r.data?.map((o) => ({
                        label: o,
                        value: o,
                      })),
                    )
                  }
                  placeholder="Search for manufacturer..."
                  value={field.value ?? []}
                  onChange={(v) => {
                    field.onChange(v);
                  }}
                />
              </FormControl>
            </FormItem>
          );
        }}
      />
      {/* <div className="flex flex-col gap-y-6 w-full">
        <div className="flex gap-x-4">
          <FormItem className="w-full grid grid-cols-2 gap-3">
            {[...manufacturers]?.slice(0, 8).map((m) => (
              <FormField
                key={m}
                name="manufacturer"
                render={({ field }) => {
                  return (
                    <FormItem className="flex !m-0 flex-row align-center gap-2">
                      <FormControl>
                        <Checkbox
                          className="w-6 h-6"
                          checked={field.value?.includes(m)}
                          onCheckedChange={(checked) => {
                            return checked
                              ? field.onChange([...field.value, m])
                              : field.onChange(field.value?.filter((value: any) => value !== m));
                          }}
                        />
                      </FormControl>
                      <FormLabel className="font-normal text-base leading-6 !m-0">{m}</FormLabel>
                    </FormItem>
                  );
                }}
              />
            ))}
          </FormItem>
        </div>
      
      </div> */}
    </div>
  );
}
